import { useMemo } from "react";
import { motion } from "framer-motion";

const IN_VIEW = { opacity: 1, y: 0 };
const VIEWPORT = { once: true, amount: 0.15 };
const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => {
  const initial = useMemo(() => ({ opacity: 0, y }), [y]);
  const transition = useMemo(() => ({ duration: 0.7, delay, ease: EASE }), [delay]);
  return (
    <motion.div className={className} initial={initial} whileInView={IN_VIEW} viewport={VIEWPORT} transition={transition}>
      {children}
    </motion.div>
  );
};

export const Eyebrow = ({ children, light = false }) => (
  <p className={`flex items-center gap-3 font-mono text-xs font-semibold uppercase tracking-[0.22em] ${light ? "text-gold-light" : "text-gold-dark"}`}>
    <span className={`h-px w-8 ${light ? "bg-gold-light" : "bg-gold-dark"}`} />
    {children}
  </p>
);
